import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=0d07d1cf&scoped=true&"
import script from "./tabIndex.vue?vue&type=script&lang=ts&"
export * from "./tabIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07d1cf",
  null
  
)

export default component.exports